import React from 'react';

export default function AuthorisedDistributorsList({items, isLoading}) {
    if (isLoading) {
        return(
            <div className='distributors-list-wrapper'>
                <div className="loader">
                    <div className="loader__icon"></div>
                </div>
            </div>
        )
    }

    return(
        <div className='distributors-list-wrapper'>
            <ul className='distributors-list'>
                {items.map(item => {
                    return (
                        <li className='distributors-list__item' key={`distributor-${item.CompanyName}`}>
                            <h5 className='distributors-list__item-company-name'>{item.CompanyName}</h5>
                            {item.Address && <h6 className='distributors-list__item-company-address'>{item.Address}</h6>}
                            <ul className='distributors-list__item-info-list'>
                                <li className='distributors-list__item-info'>
                                    <h6 className="distributors-list__item-info-title">
                                        Operates in:
                                    </h6>
                                    <span className='distributors-list__item-info-content'>{item.Country}</span>
                                </li>
                                {item.PhoneNumber &&
                                    <li className='distributors-list__item-info'>
                                        <h6 className="distributors-list__item-info-title">
                                            Phone:
                                        </h6>
                                        <span className='distributors-list__item-info-content'>
                                            <a href={"tel:" + item.PhoneNumber} itemProp="telephone">{item.PhoneNumber}</a>
                                        </span>
                                    </li>
                                }
                                {item.Email &&
                                    <li className='distributors-list__item-info'>
                                        <h6 className="distributors-list__item-info-title">
                                            E-mail:
                                        </h6>
                                        <span className='distributors-list__item-info-content'>
                                            <a href={"mailto:" + item.Email} itemProp="email">{item.Email}</a>
                                        </span>
                                    </li>
                                }
                                {item.Website &&
                                    <li className='distributors-list__item-info'>
                                        <h6 className="distributors-list__item-info-title">
                                            Website:
                                        </h6>
                                        <span className='distributors-list__item-info-content'>
                                            <a href={item.Website} itemProp="website">{item.Website}</a>
                                        </span>
                                    </li>
                                }
                            </ul>
                        </li>
                    )
                })}
            </ul>
        </div>
    )
}
